<template>
  <div class="main-container">
    <span class="error-text">You need to top up your credits first</span>
    <div class="credit-options">
      <div class="automatic-button-container">
        <div class="credit-val">+1 credit</div>
        <span>
          Arriving in
          <span style="width: 5ch; display: inline-block; text-align: left">
            {{ timer }}
          </span>
        </span>
      </div>
      <div class="button-container" @click="buyCredits(2, '0.50')">
        <div class="credit-val">+2 credits</div>
        <span>Buy for £0.50</span>
      </div>
      <div class="button-container" @click="buyCredits(5, '1.00')">
        <div class="credit-val">+5 credits</div>
        <span>Buy for £1.00</span>
      </div>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.5rem;
      "
      @click="$emit('close')"
    >
      <svg width="2rem" height="2rem" viewBox="0 0 24 24">
        <path :d="mdiChevronUp" fill="#cdf4dd" />
      </svg>
    </div>
    <!--<transition name="dialog-appear">
      <DialogConfirmFullscreen
        message="Watch the following advert to see the hint"
        button_one="Yes"
        button_two="No"
        v-if="showConfirmation"
        @button_one_click="
          !(confirmationResolve === undefined) && confirmationResolve()
        "
        @button_two_click="
          !(confirmationReject === undefined) && confirmationReject()
        "
      />
    </transition>-->
  </div>
</template>

<script>
//import DialogConfirm from '@/components/DialogConfirm.vue'
import { mdiChevronUp } from '@mdi/js'

export default {
  name: 'BuyCredits',
  //components: { DialogConfirm },
  data() {
    return {
      mdiChevronUp,
      timer: undefined,
      timerTimeout: undefined,
      refreshTime: 7200,
      showConfirmation: false,
      confirmationMessage: undefined,
      confirmationResolve: undefined,
      confirmationReject: undefined,
    }
  },
  mounted() {
    this.timerTimeout = setInterval(() => {
      const delta = Date.now() - this.$store.getters.creditRefreshStart
      const remaining = 7200 - delta / 1000
      const hours = Math.floor(remaining / 3600)
      const minutes = Math.floor((remaining - hours * 3600) / 60)
      const seconds = Math.floor(remaining - hours * 3600 - minutes * 60)
      this.timer = `${hours}:${minutes > 9 ? minutes : '0' + minutes}:${
        seconds > 9 ? seconds : '0' + seconds
      }`
    }, 100)
  },
  beforeDestroy() {
    console.log('BuyCredits beforeDestroy')
    clearInterval(this.timerTimeout)
  },
  methods: {
    buyCredits(credits = undefined, price = undefined) {
      console.log('buyCredits:', credits, price)
      new Promise((resolve, reject) => {
        /*this.confirmationMessage = `Buy ${credits} credits for ${price}?`
        this.showConfirmation = true
        this.confirmationResolve = () => {
          resolve({ credits, price })
        }
        this.confirmationReject = () => {
          reject({ credits, price })
        }*/

        this.$store.dispatch('show_confirmation_dialog', {
          message: `Buy ${credits} credits for £${price}?`,
          buttons: [
            {
              message: 'Yes',
              callBack: () => {
                resolve({ credits, price })
              },
            },
            {
              message: 'No',
              callBack: () => {
                reject({ credits, price })
              },
            },
          ],
        })
      })
        .then((vals) => {
          //this.showConfirmation = false
          this.$store.dispatch('clear_confirmation_dialog')
          this.$store.commit(
            'UPDATE_CREDIT_BALANCE',
            this.$store.getters.creditBalance + vals.credits
          )
          this.$emit('hide')
          console.log(`YES: ${vals.credits} - ${vals.price}`)
        })
        .catch((vals) => {
          //this.showConfirmation = false
          this.$store.dispatch('clear_confirmation_dialog')
          console.log(`NO: ${vals.credits} - ${vals.price}`)
        })
    },
    yesBuyCredit() {
      this.showConfirmation = false
    },
    noBuyCredit() {
      this.showConfirmation = false
    },
  },
}
</script>

<style scoped>
.main-container {
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-text {
  /*color: #ff3633;*/
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
  text-align: center;
}

.button-container {
  width: 75%;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease, opacity 0.5s ease;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.automatic-button-container {
  width: 75%;
  padding: 1em;
  text-align: center;
  border: 1px dashed #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease, opacity 0.5s ease;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (hover: hover) {
  .button-container:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

.credit-val {
  font-size: 1rem;
  background-color: #468b18;
  color: white;
  font-weight: bold;
  /*width: 4rem;
  height: 4rem;*/
  padding: 0.5rem;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
}

.credit-options {
  max-height: 60vh;
  overflow-y: scroll;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dialog-appear-enter-active,
.dialog-appear-leave-active {
  transition: all 0.3s;
}

.dialog-appear-enter,
.dialog-appear-leave-to {
  opacity: 0;
  /*transform: translate(calc(50vw - 50%), calc(50vh - 50% - 15px));*/
}
</style>
